import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { resources, type SupportedLanguage } from './resources'
import { agentSpecResources } from './agentSpecResources'

const supportedLanguages: SupportedLanguage[] = ['fr', 'en', 'es']
const storageKey = 'agent-maurice-os-language'

const resourcesWithAgentSpec = {
  ...resources,
  fr: {
    translation: {
      ...resources.fr.translation,
      agentSpec: agentSpecResources.fr,
    },
  },
  en: {
    translation: {
      ...resources.en.translation,
      agentSpec: agentSpecResources.en,
    },
  },
  es: {
    translation: {
      ...resources.es.translation,
      agentSpec: agentSpecResources.es,
    },
  },
}

if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: resourcesWithAgentSpec,
      fallbackLng: 'fr',
      supportedLngs: supportedLanguages,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: storageKey,
        caches: ['localStorage'],
      },
    })

  i18n.on('languageChanged', (language) => {
    document.documentElement.lang = supportedLanguages.includes(language as SupportedLanguage)
      ? language
      : 'fr'
  })
}

export { supportedLanguages, storageKey }
export default i18n
